type DisplayMediaOptions = Parameters<typeof navigator.mediaDevices.getDisplayMedia>[0];

// Typescript type isn't up to date https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getDisplayMedia
export const DEFAULT_MEDIA_OPTIONS: DisplayMediaOptions & { preferCurrentTab: boolean } = {
  video: { frameRate: 60, width: { ideal: 3840 }, height: { ideal: 2160 } },
  preferCurrentTab: true,
};
